// extracted by mini-css-extract-plugin
export default {"container":"TrendsList_container__HxodC","chart":"TrendsList_chart__3+Sa8"};